import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/RootCauseFamilyAndOptionsAction";
import * as api from "../../api/RootCauseFamilyAndOptionsApi";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";

function* getRootCauseFamilyAndOptions() {
    try {
        const { data } = yield api.getRootCauseFamilyAndOptions();
        yield put(actions.setRootCauseFamilyAndOptions(data || undefined));
    } catch (error) {
        yield put(actions.setRootCauseFamilyAndOptions(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(resetBackdrop());
}


function* watchAll() {
    yield takeEvery(actions.Types.GET_ROOT_CAUSE_FAMILY_AND_OPTIONS, getRootCauseFamilyAndOptions);
}

const RootCausesFamilyAndOptionsSaga = [fork(watchAll)];

export default RootCausesFamilyAndOptionsSaga;